import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, User } from "@/types";

export function useGetUser({
  enabled = true,
  userId,
}: {
  enabled?: boolean;
  userId: number;
}) {
  return useQuery({
    enabled,
    queryKey: ["users", userId],
    queryFn: async () => {
      const path = `users/${userId.toString()}`;
      const res = await guacHttpClient.get<User, HttpResponse<User>>(path);
      return res.data;
    },
  });
}
